import {
  buildAuthentication,
  clearAuthentication,
} from "helpers/authenticationHelper";
import useGlobalContext from "globalProviders/GlobalDataProvider";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ResponseCode } from "services/facultyPortalClient";
import { LinearProgress } from "@mui/material";

export default function LoginComplete() {
  const { summaryUrl, notFoundUrl, authenticationService } = useGlobalContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    async function loginCompleteCallback() {
      const sessionId = searchParams.get("sessionId")!;
      if (sessionId === null) {
        navigate(notFoundUrl());
      }

      const userResponseRaw =
        await authenticationService.loginComplete(sessionId);

      if (
        userResponseRaw.responseCode === ResponseCode.OK &&
        userResponseRaw.data?.result
      ) {
        clearAuthentication();
        buildAuthentication(userResponseRaw.data);

        window.location.href =
          userResponseRaw.data?.returnUrl || summaryUrl();
      } else {
        navigate(notFoundUrl());
      }
    }

    loginCompleteCallback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <LinearProgress />;
}
